import React from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

export default function AboutUs() {
  return (
    <DocumentTitle title={I18n.general.aboutUs}>
      <Card
        style={{ margin: 32, boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.4)" }}
        title={
          <Typography.Title level={2} style={{ paddingBottom: 0, marginBottom: 0 }}>{I18n.general.aboutUs}</Typography.Title>
        }
      >
        <Typography.Paragraph>
          وبسایت مجموعه فروش پوشاک لِنا استایل Lenna Style با اتکا به بیش از هفت
          سال حضور در مد و صنعت پوشاک پا به عرصه فروش اینترنتی نهاد. ارائه محصول
          با کیفیت و به صرفه و ارائه محصولات متنوع اصول و اهداف اولیه لِنا استایل
          بوده و خواهد بود. ما به خود مفتخریم که اجناس با کیفیت و با مناسب‌ترین
          قیمت برای مشتریان عزیز درنظر می گیریم.
        </Typography.Paragraph>
        <Typography.Paragraph>
          ما همواره سعی میکنیم تا در کمترین زمان ممکن با کمترین ضریب خطا و با
          استفاده از شیوه های نوین ثبت سفارش، ارسال و بسته بندی، محصولات خریداری
          شده را به دست مشتریان عزیز رسانده و روز به روز با نوآوری در این راه
          قدم برداریم.
        </Typography.Paragraph>
        <Typography.Paragraph>
          با تیم حرفه ای مجموعه لِنا استایل از ارائه بهترین خدمات لذت ببرید.
        </Typography.Paragraph>
        <Typography.Paragraph>
          آدرس: مشهد- بلوار وکیل آباد - بلوار جلال آل احمد - جلال آل احمد ۶۴ - پلاک ۲۵۵/۱
          تلفن: 05136030426
        </Typography.Paragraph>
      </Card>
    </DocumentTitle>
  );
}
